import type { TConstraints } from '@feathr/rachis';

import { TargetableClass } from './targetable.types';
import type { ITargetableBase } from './targetable_base';
import { TargetableBase } from './targetable_base';

/**
 * Interface for omni slice targetables
 */
export interface IOmniSliceTargetable extends ITargetableBase {
  _cls: TargetableClass.omni_slice;
  include_percent: number;
}

/**
 * OmniSliceTargetable class for omni slice targetables
 */
export class OmniSliceTargetable extends TargetableBase<IOmniSliceTargetable> {
  public override className = 'Targetable.TradedeskOmniSliceTargetable';

  public override getDefaults(): Partial<IOmniSliceTargetable> {
    return {
      ...super.getDefaults(),
      _cls: TargetableClass.omni_slice,
    };
  }

  public override get constraints(): TConstraints<IOmniSliceTargetable> {
    return {
      ...super.constraints,
      _cls: {
        inclusion: [TargetableClass.omni_slice],
      },
    };
  }
}
